<div class="te-col-center" style="padding:5px;">

    <h2 class="te-col-center" style="text-align:center" mat-dialog-title>{{'HelpDeskText3' | translate}}</h2>

    <div class="te-row-end" style="font-style:italic;">        
        * {{'LastUpdated' | translate}} <b>{{ lastUpdatedDate | date:'MM/dd/yyyy' }}</b>
    </div>

    <!-- Dropdown for mobile view filtering -->
    
    <mat-form-field appearance="outline" class="dialog-dropdown">
        <mat-label>{{'Country' | translate}}</mat-label>
        <mat-select [(value)]="selectedCountry" (selectionChange)="applyFilter()">
            <mat-option *ngFor="let country of uniqueCountries" [value]="country">
                {{ country }}
            </mat-option>
        </mat-select>
    </mat-form-field>
    

        <mat-dialog-content class="sdcontacts-dialog-content te-col-center te-modal-scroll-hide te-modal-scroll-hide-webkit" style="max-width: 100%;min-width: 100%;padding:0px;">
            <mat-card class="te-col-center te-panel">
                <div style="width: 100%; overflow-x:scroll; overflow-y:scroll">
                    <table *ngIf="filteredDataSource?.length > 0" mat-table [dataSource]="filteredDataSource" class="mat-elevation-z8 te-form-900" style="color: #333333; border-radius: 5px; width: 100%;">

                        <!-- Country Column-->
                        <ng-container matColumnDef="u_country">
                            <th mat-header-cell style="padding-left:5px" *matHeaderCellDef>
                                <h4><span style="margin-right:5px"><b>{{'Country' | translate}}</b></span></h4>
                            </th>
                            <td mat-cell style="padding-left:5px" *matCellDef="let element">
                                <span style="font-size:12px;">{{element.u_country}}</span>
                            </td>
                        </ng-container>

                        <!-- SupportDesk Column -->
                        <ng-container matColumnDef="u_support_desk">
                            <th mat-header-cell *matHeaderCellDef>
                                <h4><span style="margin-right:5px"><b>{{'SupportDesk' | translate}}</b></span></h4>
                            </th>
                            <td mat-cell *matCellDef="let element">
                                <span style="font-size:12px;">{{element.u_support_desk}}</span>
                            </td>
                        </ng-container>

                        <!-- Phone No Column -->
                        <ng-container matColumnDef="u_phone_number">
                            <th mat-header-cell *matHeaderCellDef>
                                <h4><span><b>{{'PhoneNo' | translate}}</b></span></h4>
                            </th>
                            <td mat-cell *matCellDef="let element">
                                <span style="font-size:12px;padding-right:3px;">{{element.u_phone_number}}</span>
                            </td>
                        </ng-container>

                        <!-- Header Columns -->
                        <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
                        <!-- Rows -->
                        <tr mat-row *matRowDef="let row; columns: displayedColumns;"></tr>

                    </table>
                </div>
                <mat-progress-bar *ngIf="loadingStatus" mode="indeterminate"></mat-progress-bar>

            </mat-card>
        </mat-dialog-content>


        <mat-dialog-actions style="align-self: flex-end; justify-content: flex-end;" class="te-row-full te-vert-spacer">
            <div class="te-form-350 te-row-end">
                <button mat-raised-button class="te-button-gray te-left-spacer" mat-dialog-close>{{'CrossBtnTxt' | translate}}</button>
            </div>
        </mat-dialog-actions>
    </div>
